import React from 'react'
import { useClient, useMutation } from 'jsonapi-react'
import { useHistory } from 'react-router'

import { Body } from 'layouts/basic'
import Button from 'components/Button'
import Input, { InputFileIcon } from 'components/Forms/Input'
import Label from 'components/Forms/Label'
import useAuthStore from 'store/auth'
import blankprofile from 'assets/blankprofile.png'


export default function SceneProfile(props) {
  const [uploadingPic, setUploadingPic] = React.useState(false)
  const { data: user, getUser } = useAuthStore()
  const [editUser, { isLoading }] = useMutation(user.id && [
    'users',
    user.id,
  ])
  const client = useClient()
  const history = useHistory()

  const uploadFile = async (e) => {
    const file = e.currentTarget.files[0]
    let formData = new FormData()
    formData.append('file', file)
    setUploadingPic(true)
    await client.mutate(
      [
        'users',
        user.id,
        'uploadpic',
      ],
      false,
      {
        body: formData,
        headers: {
          'Content-Type': undefined,
        },
      }
    )
    getUser()
    setUploadingPic(false)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const firstName = e.currentTarget.elements[0].value
    const lastName = e.currentTarget.elements[1].value
    const description = e.currentTarget.elements[2].value
    const url = e.currentTarget.elements[3].value

    try {
      const response = await editUser({
        firstName,
        lastName,
        description,
        url,
      })

      if (response.error) {
        throw response.error
      }
      getUser()
      history.goBack()
    } catch (error) {
      return
    }
  }

  return (
    <Body className='ml-auto mr-auto max-w-2xl w-full prose' loading={isLoading}>
      <h1>Edit profile</h1>
      <div className='w-48 h-48 relative block mb-10'>
        <InputFileIcon
          className='
            absolute cursor-pointer p-2 bottom-1 right-1
            transition-all
            bg-disabled-500 text-white
            hover:bg-primary-600
          '
          inputProps={{
            accept: 'image/jpg, image/png, image/jpeg',
          }}
          onChange={e => uploadFile(e)}
          loading={uploadingPic}
        />
        <img
          alt={user.fullName}
          src={user.profilePic?.thumbnail || blankprofile}
          className='
            shadow-lg border border-disabled-300 bg-white
            object-cover w-full h-full rounded-full block
          '
        />
      </div>
      <form onSubmit={onSubmit}>
        <Label>
          First Name *
          <Input
            inputProps={{
              defaultValue: user.firstName,
              required: true,
              placeholder: 'Your first name',
            }}
          />
        </Label>
        <Label>
          Last name *
          <Input
            inputProps={{
              defaultValue: user.lastName,
              required: true,
              placeholder: 'Your last name',
            }}
          />
        </Label>
        <Label>
          Description
          <Input
            inputProps={{
              defaultValue: user.description,
              placeholder: 'Describe yourself',
            }}
          />
        </Label>
        <Label>
          Url
          <Input
            inputProps={{
              type: 'url',
              defaultValue: user.url,
              placeholder: 'Url',
            }}
          />
        </Label>
        <div className='flex justify-between'>
          <Button
            disabled={uploadingPic}
            type='submit'
            className='rounded inverted'
            loading={isLoading}
          >Save</Button>
          <Button type='reset' theme='disabled' onClick={e => {
            e.preventDefault()
            history.goBack()
          }} className='rounded inverted'>Cancel</Button>
        </div>
      </form>
    </Body>
  )
}
